import { TabComponent } from './Tab'
import { TabContainer } from './Tab.styles'
import { TabDefault } from './TabDefault'

export type { TabProps, TabRenderProps } from './Tab'
export type { TabDefaultProps } from './TabDefault'

export const Tab = Object.assign(TabComponent, {
  Default: TabDefault,
  Styled: {
    Container: TabContainer,
  },
})
